<div class="date-time-control-container" [formGroup]="formGroup">
  <div class="date-time-control-date-container">
    <input matInput [formControlName]="formAttributes.date" [matDatepicker]="picker" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </div>
  <div class="date-time-control-time-container">
    <input
      matInput
      type="time"
      [formControlName]="formAttributes.time"
      placeholder="Select date to send or leave black for immediate send"
    />
  </div>
</div>
